import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NavbarComponent } from 'src/app/components/navbar/navbar.component';
import { NavtabsComponent } from 'src/app/components/navtabs/navtabs.component';
import { TranslationService } from 'src/app/service/translation.service';
import { environment } from 'src/environments/environment';
import { SettingsComponent } from '../settings.component';

@Component({
    selector: 'app-menu-settings',
    templateUrl: './menu-settings.component.html',
    styleUrls: ['./menu-settings.component.scss'],
    standalone: true,
    imports: [TranslateModule, NavbarComponent, NavtabsComponent, SettingsComponent],
    providers: [TranslationService]
})
export class MenuSettingsComponent implements OnInit, OnDestroy{

  readonly translationService = inject(TranslationService);
  public env = environment;
  
  ngOnDestroy(): void {
    document.body.style.backgroundColor="white";
  }
  ngOnInit(): void {
   
    this.translationService.get('menu-settings').subscribe((value) => {
      document.title = "DIP - " + value;
      document.body.style.backgroundColor = "#F1F1F4";
    });
  }

  get isDeveloperMode(): boolean {
    return this.env.env === 'develop';
  }
}